import script from "./EditButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditButton.vue?vue&type=script&lang=ts&setup=true"

import "./EditButton.vue?vue&type=style&index=0&id=35c5ea55&lang=css&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c5ea55"]])

export default __exports__